declare namespace $ {

	type $mol_view__sub_bog_blitz_profile_page_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_blitz_profile_page_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_open_native__files_bog_blitz_profile_page_3 = $mol_type_enforce<
		ReturnType< $bog_blitz_profile_page['avatar_files'] >
		,
		ReturnType< $mol_button_open_native['files'] >
	>
	type $mol_button_open_native__accept_bog_blitz_profile_page_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open_native['accept'] >
	>
	type $mol_button_open_native__multiple_bog_blitz_profile_page_5 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_button_open_native['multiple'] >
	>
	type $mol_button_open__sub_bog_blitz_profile_page_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_open['sub'] >
	>
	type $mol_string_button__hint_bog_blitz_profile_page_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string_button['hint'] >
	>
	type $mol_string_button__value_bog_blitz_profile_page_8 = $mol_type_enforce<
		ReturnType< $bog_blitz_profile_page['profile_name'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_view__sub_bog_blitz_profile_page_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_blitz_profile_page_10 = $mol_type_enforce<
		ReturnType< $bog_blitz_profile_page['stat_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_blitz_profile_page_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_blitz_profile_page_12 = $mol_type_enforce<
		ReturnType< $bog_blitz_profile_page['persona_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_blitz_profile_page_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_blitz_profile_page_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_blitz_profile_page_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_search__query_bog_blitz_profile_page_16 = $mol_type_enforce<
		ReturnType< $bog_blitz_profile_page['games_query'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_list__rows_bog_blitz_profile_page_17 = $mol_type_enforce<
		ReturnType< $bog_blitz_profile_page['game_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_bog_blitz_profile_page_18 = $mol_type_enforce<
		ReturnType< $bog_blitz_profile_page['games_empty_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_blitz_profile_page_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_blitz_profile_page_20 = $mol_type_enforce<
		ReturnType< $bog_blitz_profile_page['stat_label'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_blitz_profile_page_21 = $mol_type_enforce<
		ReturnType< $bog_blitz_profile_page['stat_value'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_blitz_profile_page_22 = $mol_type_enforce<
		ReturnType< $bog_blitz_profile_page['game_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_blitz_profile_page_23 = $mol_type_enforce<
		ReturnType< $bog_blitz_profile_page['game_details'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_blitz_profile_page_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_blitz_profile_page_25 = $mol_type_enforce<
		ReturnType< $bog_blitz_profile_page['game_score'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_image__uri_bog_blitz_profile_page_26 = $mol_type_enforce<
		ReturnType< $bog_blitz_profile_page['avatar_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_avatar__id_bog_blitz_profile_page_27 = $mol_type_enforce<
		ReturnType< $bog_blitz_profile_page['player_id'] >
		,
		ReturnType< $mol_avatar['id'] >
	>
	type $mol_view__sub_bog_blitz_profile_page_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_bog_blitz_profile_page_29 = $mol_type_enforce<
		ReturnType< $bog_blitz_profile_page['game_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_blitz_profile_page_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	export class $bog_blitz_profile_page extends $mol_page {
		avatar_preview( ): any
		Avatar_circle( ): $mol_view
		Avatar_label( ): $mol_paragraph
		avatar_files( next?: readonly(File)[] ): readonly(File)[]
		Avatar_native( ): $mol_button_open_native
		Avatar( ): $mol_button_open
		profile_name( next?: string ): string
		Name_input( ): $mol_string_button
		Name_row( ): $mol_view
		stat_rows( ): readonly(any)[]
		Stats( ): $mol_view
		Fun_title( ): $mol_paragraph
		persona_text( ): string
		Fun_text( ): $mol_paragraph
		Fun_card( ): $mol_view
		Card( ): $mol_view
		Games_title( ): $mol_paragraph
		games_query( next?: string ): string
		Games_search( ): $mol_search
		game_rows( ): readonly(any)[]
		Games_list( ): $mol_list
		games_empty_text( ): string
		Games_empty( ): $mol_paragraph
		Games_section( ): $mol_view
		avatar_uri( ): string
		player_id( ): string
		stat_label( id: any): string
		Stat_label( id: any): $mol_paragraph
		stat_value( id: any): string
		Stat_value( id: any): $mol_paragraph
		game_arg( id: any): Record<string, any>
		game_title( id: any): string
		Game_title( id: any): $mol_paragraph
		game_details( id: any): string
		Game_details( id: any): $mol_paragraph
		Game_info( id: any): $mol_view
		game_score( id: any): string
		Game_score( id: any): $mol_paragraph
		Head( ): any
		body( ): readonly(any)[]
		Avatar_image( ): $mol_image
		Avatar_icon( ): $mol_avatar
		Stat_row( id: any): $mol_view
		Game_row( id: any): $mol_link
	}
	
}

//# sourceMappingURL=profile.view.tree.d.ts.map